export const HOME = {
  emergentLink: "home-emergent-link",
};

export const LANDING = {
  googleSignInBtn: "landing-google-signin-btn",
  heroTitle: "landing-hero-title",
};

export const LOBBY = {
  container: "lobby-container",
  createRoomBtn: "lobby-create-room-btn",
  joinRoomInput: "lobby-join-room-input",
  joinRoomBtn: "lobby-join-room-btn",
  quickMatchBtn: "lobby-quick-match-btn",
  friendsLink: "lobby-friends-link",
  leaderboardLink: "lobby-leaderboard-link",
  profileLink: "lobby-profile-link",
  storeLink: "lobby-store-link",
  logoutBtn: "lobby-logout-btn",
  modeBtnPrefix: "lobby-mode-",
};

export const STORE = {
  container: "store-container",
  coinsBadge: "store-coins-badge",
  buyBtnPrefix: "store-buy-",
  equipBtnPrefix: "store-equip-",
  tabUno: "store-tab-uno",
  tabSkipbo: "store-tab-skipbo",
  tabCoins: "store-tab-coins",
  bundleBuyPrefix: "store-bundle-buy-",
};

export const LOADOUT = {
  container: "loadout-container",
  selectUnoPrefix: "loadout-select-uno-",
  selectSbPrefix: "loadout-select-sb-",
  saveBtn: "loadout-save-btn",
};

export const ADMIN = {
  container: "admin-container",
  giftIdInput: "admin-gift-id-input",
  giftAmountInput: "admin-gift-amount-input",
  giftBtn: "admin-gift-btn",
  selfTopupInput: "admin-self-topup-input",
  selfTopupBtn: "admin-self-topup-btn",
};

export const SKIPBO = {
  container: "skipbo-container",
  buildPilePrefix: "skipbo-build-",
  discardPilePrefix: "skipbo-discard-",
  stockpileBtn: "skipbo-stockpile-btn",
  handCardPrefix: "skipbo-hand-",
  endTurnBtn: "skipbo-end-turn-btn",
  targetBuildPrefix: "skipbo-target-build-",
  targetDiscardPrefix: "skipbo-target-discard-",
};

export const GAME = {
  container: "game-container",
  startBtn: "game-start-btn",
  drawBtn: "game-draw-btn",
  unoBtn: "game-uno-btn",
  addBotBtn: "game-add-bot-btn",
  restartBtn: "game-restart-btn",
  leaveBtn: "game-leave-btn",
  chatInput: "game-chat-input",
  chatSendBtn: "game-chat-send-btn",
  chatToggleBtn: "game-chat-toggle-btn",
  colorChooserRed: "color-chooser-red",
  colorChooserYellow: "color-chooser-yellow",
  colorChooserGreen: "color-chooser-green",
  colorChooserBlue: "color-chooser-blue",
  copyRoomCodeBtn: "game-copy-room-code",
};

export const FRIENDS = {
  container: "friends-container",
  searchInput: "friends-search-input",
  addBtnPrefix: "friends-add-btn-",
  removeBtnPrefix: "friends-remove-btn-",
  inviteBtnPrefix: "friends-invite-btn-",
  acceptBtnPrefix: "friends-accept-btn-",
  declineBtnPrefix: "friends-decline-btn-",
  cancelBtnPrefix: "friends-cancel-btn-",
  joinBtnPrefix: "friends-join-btn-",
  tabPrefix: "friends-tab-",
};

export const PROFILE = {
  container: "profile-container",
  nameInput: "profile-name-input",
  saveBtn: "profile-save-btn",
  avatarBtnPrefix: "profile-avatar-",
};

export const LEADERBOARD = {
  container: "leaderboard-container",
};
